import { ToastColorTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { FormControl } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { DefaultFormFields, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms/FormController';
import { makeAutoObservable } from 'mobx';
import { RootStore } from 'store/rootStore';
import { ToastInfo } from 'types/general';

interface QuoteFields extends DefaultFormFields {
  email: FormControl<string>;
  name: FormControl<string>;
  message: FormControl<string>;
}

export class QuoteModalStore {
  rootStore: RootStore;
  form: FormController<QuoteFields>;
  loading = false;
  // Toast Info
  toastInfo: ToastInfo = {
    showToast: false,
    toastType: ToastColorTypes.SUCCESS,
    toastMessage: '',
  };

  setLoading(loadingStatus: boolean): void {
    this.loading = loadingStatus;
  }

  async saveQuoteModalChanges(cartId: string, groupId: string, sponsorId: string, onClose: () => void): Promise<void> {
    this.setLoading(true);
    const { email, message, name } = this.form.fields;
    await this.rootStore.cartStore
      .saveQuote(cartId, groupId, sponsorId, email.value, message.value, name.value)
      .then((response) => {
        if (response.data?.saveQuote) {
          this.showToast('Email was successfully sent.', ToastColorTypes.SUCCESS);
        }
      })
      .catch(() => {
        this.showToast('Something went wrong', ToastColorTypes.WARNING);
      })
      .finally(() => {
        onClose();
        this.setLoading(false);
        this.form.resetForm();
      });
  }

  showToast(toastMessage: string, type: ToastColorTypes): void {
    this.resetToastInfo();
    this.toastInfo.showToast = true;
    this.toastInfo.toastMessage = toastMessage;
    this.toastInfo.toastType = type;
  }

  closeToast(): void {
    this.toastInfo.showToast = false;
    this.resetToastInfo();
  }

  resetToastInfo(): void {
    this.toastInfo.toastType = ToastColorTypes.SUCCESS;
    this.toastInfo.toastMessage = '';
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    this.form = new FormController({
      email: new FormControl<string>('', { validations: ['isEmailValid'] }),
      name: new FormControl<string>(''),
      message: new FormControl<string>('', { optional: true }),
    });

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
